"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShepherdReportModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_i18n_1 = require("@snapchat/web-i18n");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const messageLoader_1 = require("../../../i18n/messageLoader");
const PlayerModal_1 = require("../PlayerModal");
const constants_1 = require("./constants");
const ReportModalContent_1 = require("./ReportModalContent");
/**
 * Report modal for snap content
 */
function ShepherdReportModal({ isVisible, onSubmit, onModalClose, isMobile, playNext, locale, }) {
    const [resolvedLocale] = (0, react_1.useState)((0, web_i18n_1.getLocale)(locale));
    const [messages, setMessages] = (0, react_1.useState)({});
    const [categories, setCategories] = (0, react_1.useState)();
    const [selectedReason, setSelectedReason] = (0, react_1.useState)();
    const [reportDescription, setReportDescription] = (0, react_1.useState)();
    const [withBackButton, setWithBackButton] = (0, react_1.useState)(false);
    const [withDescriptionField, setWithDescriptionField] = (0, react_1.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, react_1.useState)(false);
    const timerRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        let isSubscribed = true;
        void (0, messageLoader_1.loadMessages)(resolvedLocale).then((messages) => {
            if (isSubscribed) {
                setMessages(messages);
            }
        });
        return function cleanup() {
            isSubscribed = false;
        };
    }, [resolvedLocale]);
    const onBackButtonClick = (0, react_1.useCallback)(() => {
        setWithBackButton(false);
        setWithDescriptionField(false);
        setReportDescription(""); // Erase report description if there was one
        setCategories(undefined);
        setSelectedReason(undefined);
    }, []);
    const onCategoryClick = (0, react_1.useCallback)((id) => {
        // If a category has a custom link, open that.
        const category = constants_1.DEFAULT_CATEGORIES.get(id);
        if (category?.reportLink) {
            window.open(category.reportLink);
            return;
        }
        const subCategory = category?.subCategory;
        if (subCategory) {
            setCategories(subCategory);
            setWithBackButton(true);
            setWithDescriptionField(false);
            setReportDescription("");
            setSelectedReason(undefined);
        }
        else {
            setSelectedReason(id.reason);
            setWithDescriptionField(true);
        }
    }, []);
    const onReasonClick = (0, react_1.useCallback)((reason) => {
        setSelectedReason(reason);
        setWithDescriptionField(true);
    }, []);
    const onReportDescriptionChange = (0, react_1.useCallback)((description) => {
        setReportDescription(description);
    }, []);
    const onModalRefresh = (0, react_1.useCallback)(() => {
        setSelectedReason(undefined);
        setWithBackButton(false);
        setWithDescriptionField(false);
        setReportDescription("");
    }, []);
    const onReportSubmitted = (0, react_1.useCallback)(() => {
        setHasSubmitted(false);
        onModalClose();
        onModalRefresh();
        playNext?.();
    }, [onModalClose, onModalRefresh, playNext]);
    const onModalSubmit = (0, react_1.useCallback)(() => {
        if (!selectedReason) {
            onModalRefresh();
            return;
        }
        onSubmit({
            reason: selectedReason,
            reportDescription,
        });
        setHasSubmitted(true);
        timerRef.current = window.setTimeout(() => {
            onReportSubmitted();
        }, constants_1.DELAY_AFTER_SUBMIT);
    }, [selectedReason, onSubmit, reportDescription, onModalRefresh, onReportSubmitted]);
    const onModalCancel = (0, react_1.useCallback)(() => {
        onModalRefresh();
        onModalClose();
    }, [onModalRefresh, onModalClose]);
    const onUserModalCancel = (0, react_1.useCallback)(() => {
        clearTimeout(timerRef.current);
        onReportSubmitted();
    }, [onReportSubmitted]);
    const modalContent = ((0, jsx_runtime_1.jsx)(ReportModalContent_1.ReportModalContent, { reportCategories: categories, withBackButton: withBackButton, withDescriptionField: withDescriptionField, onBackButtonClick: onBackButtonClick, onCategoryClick: onCategoryClick, onReasonClick: onReasonClick, onReportDescriptionChange: onReportDescriptionChange, textFieldTitle: constants_1.TEXTFIELD_TITLE, textFieldDescription: reportDescription, selectedReason: selectedReason, isMobile: isMobile, hasSubmitted: hasSubmitted }));
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: resolvedLocale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: (0, jsx_runtime_1.jsx)(PlayerModal_1.PlayerModal, { title: hasSubmitted ? constants_1.REPORT_SUBMITTED_HEADER : constants_1.REPORT_SNAP, modalContent: modalContent, primaryButtonLabel: hasSubmitted ? constants_1.CLOSE_BUTTON : selectedReason ? constants_1.SUBMIT_BUTTON : null, secondaryButtonLabel: !hasSubmitted ? constants_1.CANCEL_BUTTON : null, onPrimaryButtonClick: hasSubmitted ? onUserModalCancel : onModalSubmit, onSecondaryButtonClick: onModalCancel, isVisible: isVisible }) }));
}
exports.ShepherdReportModal = ShepherdReportModal;
//# sourceMappingURL=ShepherdReportModal.js.map